import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-show-more-names',
  templateUrl: './show-more-names.component.html',
  styleUrls: ['./show-more-names.component.scss']
})
export class ShowMoreNamesComponent implements OnInit, OnChanges {

  @Input() names: string;
  @Input() searchText: string;

  public onlyName: string;
  public showMore = false;
  public namesList: any;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.names && changes.names.currentValue) {
      this.showMore = false;
      const names = this.names.split(',');
      this.namesList = names;
      if(names.length) {
        this.onlyName = names[0];
      } else {
        this.showMore = true;
      }
      this.names = names.join(', ');
    }
  }

  ngOnInit(): void {
  }

  public onMoreClick(): void {
    this.showMore = true;
  }

}
